//@flow
import { isValidPhoneNumber } from 'react-phone-number-input'

export const checkEmailValidity = (email: string): boolean =>
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  )

export const checkPasswordValidity = (name: string): boolean =>
  /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){6,128}$/.test(name)

export const checkFrPhoneNumber = (phoneNumber: string): boolean => {
  return phoneNumber ? isValidPhoneNumber(phoneNumber) : false
}

export const checkFrVatNumber = (vatNumber: string): boolean =>
  /^(FR)?[0-9A-Z]{2}[0-9]{9}$/.test(String(vatNumber))
